import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var chevron_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z" }) });
export {
  chevron_right_default as default
};
//# sourceMappingURL=chevron-right.js.map
